function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * done
 */

import { useField } from '@formily/react';
import { Cascader } from 'antd';
import cx from 'classnames';
import React from 'react';
import { useClear, useCssInJs, useDict, useParams, usePlaceholder, wrapReactionHook } from "../../hooks";
import { DictCascaderText } from "../DictCascaderText";
import { genDictCascaderStyles } from "./styles";
export var DictCascader = wrapReactionHook(function (props) {
  var defaultPlaceholder = usePlaceholder();
  var _props$autoClear = props.autoClear,
    autoClear = _props$autoClear === void 0 ? [] : _props$autoClear,
    dictType = props.dictType,
    dictMap = props.dictMap,
    onChange = props.onChange,
    value = props.value,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? defaultPlaceholder : _props$placeholder,
    _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    _props$childrenLoadLe = props.childrenLoadLevel,
    childrenLoadLevel = _props$childrenLoadLe === void 0 ? 5 : _props$childrenLoadLe,
    url = props.url,
    autoRemoveDict = props.autoRemoveDict,
    _props$params = props.params,
    params = _props$params === void 0 ? {} : _props$params,
    readOnly = props.readOnly,
    disabled = props.disabled;
  var prefix = 'form-dict-cascader';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genDictCascaderStyles
    }),
    hashId = _useCssInJs.hashId,
    wrapSSR = _useCssInJs.wrapSSR;
  var clear = useClear(autoClear);
  var getParams = useParams(params);
  var field = useField();
  var enums = field && field.dataSource;
  var dictParams = {
    level: level,
    childrenLoadLevel: childrenLoadLevel,
    url: url,
    params: getParams(),
    autoRemoveDict: autoRemoveDict,
    dictMap: dictMap,
    enums: enums
  };
  var options = useDict(dictType, dictParams);
  var handleChange = function handleChange(select) {
    clear();
    onChange === null || onChange === void 0 || onChange(select);
  };
  if (readOnly) {
    return /*#__PURE__*/React.createElement(DictCascaderText, _extends({}, dictParams, {
      dictType: dictType,
      value: value
    }));
  }
  return wrapSSR( /*#__PURE__*/React.createElement(Cascader, {
    className: cx(prefix, hashId),
    options: options,
    value: value,
    onChange: handleChange,
    placeholder: placeholder,
    disabled: disabled
  }));
});